module.exports = __webpack_public_path__ + "static/media/about.7e3e78d6.JPG";